export async function getList({commit}) {
  const {data} = await this.$adminRepositories.appTags.index();
  return commit('setList', data.data);
}

export async function getListExceptId({commit}) {
  const {data} = await this.$adminRepositories.appTags.getListExceptId();
  return commit('setListExceptId', data.data);
}

export async function deleteTagById({commit}, payload) {
  const response = await this.$adminRepositories.appTags.delete(payload.id);
  const {errResponse, data: responseData} = response;

  if (!errResponse && responseData.success) {
    commit('removeItem', payload.id);
  }

  return response;
}

export async function createTag({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const {data} = await this.$adminRepositories.appTags.create(payload);
  commit('setBtnLoading', false, {root: true});
  return data;
}

export async function updateTag({commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const {data} = await this.$adminRepositories.appTags.update(payload.id, payload);
  commit('setBtnLoading', false, {root: true});
  return data;
}

export async function findTagById({commit}, payload) {
  const {data} = await this.$adminRepositories.appTags.show(payload);
  return data;
}
